import moment from "moment-timezone";

export default function MomentPlugin(app) {
    moment.locale(app.env.get('app.locale', 'en'));
    moment.tz.setDefault("Europe/Copenhagen");
    moment.suppressDeprecationWarnings = true;
}
